import * as React from 'react'
import { styled } from 'next-yak'

import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'
import { lightweight, standalone, type SymbolProps } from '../../spritesheetUtils'

const ID = 'pinterest-third-party-glyph-icon'

export function PinterestSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 19 23">
      <path d="M4.3555 22.996c-.1094-.0937-.1094-.2265-.129-.3476-.1757-1.1953-.289-2.3906-.2421-3.5976.0312-.8594.2734-1.6797.4804-2.504.461-1.8398.922-3.6796 1.3907-5.5156.0351-.1289.0156-.2382-.0313-.3632-.4922-1.3242-.5742-2.6485.1485-3.918.4492-.793 1.1445-1.293 2.0976-1.3516 1.086-.0664 1.8828.6524 1.9414 1.7266.039.6406-.1133 1.25-.2969 1.8516a175.5006 175.5006 0 01-.8671 2.7773c-.5235 1.6328.7304 2.789 2.2148 2.75 1.2773-.0312 2.2773-.6133 3.0703-1.5664.789-.9492 1.2266-2.0508 1.4258-3.25.2226-1.3594.1172-2.6875-.4531-3.9531-.8047-1.8008-2.25-2.8125-4.1914-3.1485-1.5938-.2734-3.1641-.1718-4.629.543-2.2695 1.1055-3.4648 2.9336-3.5468 5.4258-.0352 1.1367.3125 2.1797 1.0664 3.0703.125.1484.1875.3008.1367.4922-.121.4765-.2344.957-.371 1.4336-.1134.3984-.2266.4414-.6016.2656-.879-.414-1.5079-1.086-1.9649-1.9062-1.4805-2.6446-1.2656-5.2579.2695-7.7852C2.4336 2.211 4.2227 1.0625 6.379.4727c2.1836-.5938 4.3828-.6563 6.5625 0 2.1914.6601 3.9375 1.9101 5.082 3.8945.7813 1.3594 1.0625 2.8281.9532 4.3789-.1094 1.586-.5352 3.0742-1.3946 4.4219-1.1015 1.7383-2.6289 2.9218-4.6797 3.3828-1.2382.2773-2.4687.2812-3.6523-.2774-.543-.2578-1.0117-.5976-1.3633-1.1289-.2265.8086-.4726 1.582-.6523 2.3711-.461 1.9805-1.4805 3.6914-2.6328 5.3399-.0352.0508-.0743.0937-.1094.1406zm0 0" />
    </symbol>
  )
}

const PinterestStandaloneContent = standalone(PinterestSymbol, ID)

export const Pinterest = styled(function PinterestStandaloneComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-pinterest">
      <PinterestStandaloneContent />
    </Icon>
  )
})``

export const PinterestLightweight = styled(function PinterestComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="social-pinterest">
      {lightweight(ID)}
    </Icon>
  )
})``
